import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent, DistributorLayoutComponent, PublicLayoutComponent } from './containers';
import { adminroutes } from './components/admin/admin-routing.component';
import { TestCitaComponent } from './components/public/test-cita/test-cita.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login/:idUser/:token',
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'distributor-login/:idUser/:token/:idBudget',
    loadChildren: () => import('./components/distributor/login/distributor-login.module').then(m => m.DistributorLoginModule)
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./components/public/public.module').then(m => m.PublicModule), data: { animation: 'public' } }
    ]
  },
  {
    path: 'test-cita',
    component: TestCitaComponent,
    data: { title: 'Test de cita' }
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: adminroutes
  },
  {
    path: 'distributor',
    component: DistributorLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./components/distributor/distributor.module').then(m => m.DistributorModule), data: { animation: 'distributor' } }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
